import React from "react";
import Slider from "react-slick";

const homepage_sliders = (props) => {
  const verticalSlider = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 1800,
  };

  const homepageSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="vertical d-none d-lg-block">
        <Slider {...verticalSlider}>
          {props.galleries.map((gallery) => {
            return (
              <div key={gallery.id}><img src={`${process.env.REACT_APP_IMAGE_STORAGE}${gallery.image}`} alt="" className="verticalControl" /></div>
            )
          })}
        </Slider>
      </div>
      <div className="horizontal d-lg-none">
        <Slider {...homepageSlider}>
        {props.galleries.map((gallery) => {
            return (
              <div key={gallery.id}><img src={`${process.env.REACT_APP_IMAGE_STORAGE}${gallery.image}`} alt="" className="horizontalControl" /></div>
            )
          })}
        </Slider>
      </div>
    </>
  );
};

export default homepage_sliders;
